import React, { useEffect, useState } from 'react';
import Header from './Header';
import useAuth from '../../hooks/useAuth';

/**
 * Home page component with feed
 * @returns {JSX.Element} Home page component
 */
const MainLayout = ({children}) => {
//   const { isAuth } = useAuth();
  return (
    <div className="bg-gray-100 min-h-screen">
      <Header />
      {children}
    </div>
  );
};

export default MainLayout;